
const CancelRequest = {
  "gdsRefrenceID": "string"
  };
 

  export default CancelRequest;
  